export function openCenteredPopup(url: string, title: string, w = 500, h = 600) {
  const dualScreenLeft =
    window.screenLeft !== undefined ? window.screenLeft : window.screenX;
  const dualScreenTop =
    window.screenTop !== undefined ? window.screenTop : window.screenY;

  const width = window.innerWidth
    ? window.innerWidth
    : document.documentElement.clientWidth;
  const height = window.innerHeight
    ? window.innerHeight
    : document.documentElement.clientHeight;

  const systemZoom = width / window.screen.availWidth;
  const left = dualScreenLeft + (width - w) / 2 / systemZoom;
  const top = dualScreenTop + (height - h) / 2 / systemZoom;

  const popup = window.open(
    url,
    title,
    `
      scrollbars=yes,
      width=${w}, 
      height=${h}, 
      top=${top}, 
      left=${left}
    `
  );

  if (popup && popup.focus) {
    popup.focus();
  }

  return popup;
}